import { ValidationError } from 'yup';
import { useMutation } from '@tanstack/react-query';
import { deleteItem } from '../../services/items';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: (message: string) => void | Promise<void>;
  onMutate?: () => void | Promise<void>;
  onSettled?: () => void | Promise<void>;
}

function useDeleteItem({
  onSuccess,
  onError,
  onMutate,
  onSettled,
}: Options = {}) {
  return useMutation({
    mutationFn: async ({ itemId }: { itemId: string }) =>
      deleteItem({
        itemId,
      }),
    onSuccess,
    onError: (error: Error) => {
      if (error instanceof ValidationError) {
        onError?.(error.message);
        return;
      }
      onError?.('Failed to delete item');
    },
    onMutate,
    onSettled,
  });
}

export default useDeleteItem;
